import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";
import { TPackage } from "admin/finance/types";

export const QUERY_KEY_FOR_RECRUITER_PACKAGE = "recruiter_package";

const getData = async (props: {
  token: string;
}): Promise<TPackage[]> => {
  const url = `${END_POINT.BASE_URL}/v1/packages?account_type=recruiter&enterprise=1`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const res = await axios.get(url, config);
  const item: TPackage[] = res.data;
  return item;
};

export const useGetRecruiterPackage = () => {
  const { token } = useGetUserInfo();
  const queryData = useQuery(
    [QUERY_KEY_FOR_RECRUITER_PACKAGE],
    () => getData({
        token,
    }),
    {
      onError: (err: any) => {},
      onSuccess: (data) => {},
    }
  );
  return queryData;
};

const getPackages = async (token: string) => {
  const res = await axios.get(`${END_POINT.BASE_URL}/v1/packages`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const useGetRecruiterPackageNew = () => {
  const { token } = useGetUserInfo();

  return useQuery([QUERY_KEY_FOR_RECRUITER_PACKAGE], () => getPackages(token), {
    enabled: !!token,
    select: (data) => {
      return data.filter((item: any) => item.account_type === "recruiter");
    },
  });
};

export const fetchTotalPackages = async (token: string) => {
  const res = await axios.get(
    // `https://test.arnopro.com/api/v1/packages?accountType=recruiter`,
    `${END_POINT.BASE_URL}/v1/packages?accountType=recruiter`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return res.data;
};

export const useGetTotalPackagesQuery = () => {
  const { token } = useGetUserInfo();

  return useQuery(["total_packages"], () => fetchTotalPackages(token), {
    enabled: !!token,
    onError: (err) => {
      console.error("Error fetching packages:", err);
    },
  });
};

export const fetchCurrentSubcription = async (token: string) => {
  const res = await axios.get(
    // `https://test.arnopro.com/api/v1/subscription-rules/status`,
    `${END_POINT.BASE_URL}/v1/subscription-rules/status`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return res.data;
};

export const useGetCurrentSubQuery = () => {
  const { token } = useGetUserInfo();

  return useQuery(
    ["current_subscription"],
    () => fetchCurrentSubcription(token),
    {
      enabled: !!token,
      onError: (err) => {
        console.error("Error fetching packages:", err);
      },
    },
  );
};

const getPackagesByStatus = async (token: string) => {
  const res = await axios.get(
    `${END_POINT.BASE_URL}/v1/subscription-rules/status-by-package?accountType=recruiter`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return res.data;
};

export const useGetPackagesByStatus = () => {
  const { token } = useGetUserInfo();

  return useQuery(["packages_by_status"], () => getPackagesByStatus(token), {
    enabled: !!token,
    onError: (err) => {
      console.error("Error fetching packages:", err);
    },
  });
};
